<template>
  <el-dialog
    width="360px"
    title="移动到文件夹"
    class="kye-dialog__modal-in-tab"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    :visible.sync="show"
    custom-class="kye-custom-folder-move"
    @close="onClose">
    <div class="custom-folder-move">
      <div>被移动文件名称：{{folderItem.name}}</div>
      <div class="custom-folder-move_list">
        <div class="custom-folder-move_list_cell cell-hover" @click="selectFolder(0)">
          <img style="margin-left: 14px" src="./assets/custom-folder.svg"/>
          根目录
          <span style="flex:1;"></span>
          <img v-if="selectedId === 0" src="./assets/custom-folder-selected.svg" />
        </div>
        <div v-for="(item, index) in list" v-if="item.folderFlag === 1" class="custom-folder-move_list_cell cell-hover" :key="index" @click="selectFolder(item.id)">
          <img style="margin-left: 30px" src="./assets/custom-folder.svg"/>
          {{item.name}}
          <span style="flex:1;"></span>
          <img v-if="selectedId === item.id" src="./assets/custom-folder-selected.svg" />
        </div>
      </div>
    </div>
    <template slot="footer">
      <el-button type="primary" @click="submit">保存</el-button>
      <el-button @click="show = false">取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'folder-move-dialog',
    props: {
      folderModel: Object,
      list: {
        type: Array,
        default: () => []
      },
      folderItem: {
        type: Object,
        default: () => {}
      },
      model: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        show: false,
        fileName: '',
        selectedId: '',
        rules: {
          name: [
            { required: true, message: '请输入文件夹名称', trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      async submit () {
        await this.saveMoveFolder()
        this.$emit('change')
        this.show = false
      },
      async saveMoveFolder() {
        const folderItem = this.list.find(i => i.id === this.selectedId)
        const displaySequence = folderItem ? folderItem.templateList.length : this.list.length
        const data = {
          templateList: [{
            id: this.folderItem.id,
            displaySequence: displaySequence + 1,
            parentId: this.selectedId
          }],
        }
        await this.$http('system.genericSearch.template.update.sort', data)
      },
      selectFolder (val) {
        this.selectedId = val
      },
      onClose () {
        this.$refs.form && this.$refs.form.clearValidate()
      }
    }
  }
</script>

<style lang="scss">
  .kye-custom-folder-move > .el-dialog__body {
    padding-bottom: 1px;
  }
  .custom-folder-move {
    font-size: 12px;
    color: #333333;
    &_list {
      border: 1px solid #dcdcdc;
      border-radius: 4px;
      margin-top: 6px;
      margin-bottom: 16px;
      overflow: auto;
      height: 180px;
      &_cell {
        display: flex;
        align-items: center;
        line-height: 32px;
        img {
          // margin-left: 14px;
          margin-right: 6px;
        }
      }
      .cell-hover {
        &:hover{
          background: #ebecf0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/folder-move-dialog.vue